import React, { useState, useEffect } from "react";
import axios from "axios";

const Stats = () => {
  const [contests, setContests] = useState(null);
  const [submissions, setSubmissions] = useState(null);
  const [votes, setVotes] = useState(null);

  const getInternalStats = () => {
    try {
      axios.get(`${process.env.REACT_APP_BACKEND_API_SERVER}/stats`).then(
        (response) => {
          console.log(response.data);
          setContests(response.data["totalContests"]);
          setSubmissions(response.data["totalSubmissions"]);
          setVotes(response.data["totalVotes"]);
        },
        (error) => {
          alert(error);
        }
      );
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    getInternalStats();
  }, []);

  return (
    <>
      {contests && submissions && votes && (
        <div className="container lg:pb-24 pb-0 px-6 mx-auto md:mt-6 mt-24">
          <section className="text-gray-800 text-center">
            <div className="grid gap-x-6 lg:gap-x-12 md:grid-cols-3">
              <div className="mb-12 md:mb-0">
                <h2 className="text-3xl font-bold display-5 text-green-600 mb-4">
                  {submissions}+
                </h2>
                <div className="flex text-center justify-center">
                  <h5 className="text-white text-lg font-medium mb-4 w-2/3">
                    Songs submitted from artists all over the world
                  </h5>
                </div>
                {/* <div className="flex text-center justify-center">
                  <p className="text-gray-400 w-2/3">
                    Songs submitted from artists all over the world
                  </p>
                </div> */}
              </div>

              <div className="mb-12 md:mb-0">
                <h2 className="text-3xl font-bold display-5 text-yellow-300 mb-4">
                  {votes}+
                </h2>
                <div className="flex text-center justify-center">
                  <h5 className="text-white text-lg font-medium mb-4 w-2/3">
                    Total votes from music lovers around the world
                  </h5>
                </div>
                {/* <div className="flex text-center justify-center">
                  <p className="text-gray-400 w-2/3">
                    Total votes from music lovers around the world
                  </p>
                </div> */}
              </div>

              <div className="mb-12 md:mb-0">
                <h2 className="text-3xl font-bold display-5 text-blue-300 mb-4">
                  {contests}+
                </h2>
                <div className="flex text-center justify-center">
                  <h5 className="text-white text-lg font-medium mb-4 w-2/3">
                    Contests with up-and-coming artists from around the world
                  </h5>
                </div>
                {/* <div className="flex text-center justify-center">
                  <p className="text-gray-400 w-2/3">
                    Contests with up-and-coming artists from around the world
                  </p>
                </div> */}
              </div>
            </div>
            {/* <p className="text-white font-bold md:mt-12 text-lg">
              And Counting...
            </p> */}
          </section>
          {/* <hr className="lg:hidden mt-6 " /> */}
        </div>
      )}
    </>
  );
};

export default Stats;
